<section class="section breadcrumbs-custom">
    <div class="breadcrumbs-custom-main bg-image bg-primary">
        <div class="container">
            <h3 id="textInImage" class="breadcrumbs-custom-title">Επεξεργασία Θέσης Εργασίας</h3>
        </div>
    </div>
    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul class="breadcrumbs-custom-path">
                <li><a routerLink="/home">Αρχική</a></li>
                <li><a [routerLink]="['/employer/profile', authService.getCompanyId()]">Επιχείρηση</a></li>
                <li class="active">Επεξεργασία Θέσης Εργασίας</li>
            </ul>
        </div>
    </div>
</section>
<section *ngIf="postJobForm" class="section section-md">
    <div class="container">
        <app-alert-message *ngIf="companyActivationStatus === 'pending' || companyActivationStatus === 'disapproved'" [alertOption]="alertOptionForActivationStatus"></app-alert-message>
        <form [formGroup]="postJobForm" *ngIf="metadata$ | async as metadata">
            <div class="block-form">

                <h4>Πληροφορίες Θέσης Εργασίας</h4>
                <hr>

                <div class="rd-form rd-mailform form-lg">
                    <div class="row row-40">

                        <!-- title -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-email">Τίτλος Θέσης</label>
                                <div class="form-wrap-inner">
                                    <input placeholder="" class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid" id="general-information-title" type="text" name="title" formControlName="title" data-constraints="@Required" [ngClass]="{ 'is-invalid': submitted && formControls.title.errors }">
                                    <div *ngIf="submitted && formControls.title.errors" class="text-danger">
                                        <div *ngIf="formControls.title.errors.required">* Υποχρεωτικό πεδίο</div>
                                        <div *ngIf="formControls.title.errors.maxlength">* Ο μέγιστος αριθμός χαρακτήρων είναι 255.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- email -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-email">Ηλεκτρονικό Ταχυδρομείο</label>
                                <div class="form-wrap-inner">
                                    <input placeholder="" class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid" id="general-information-email" type="text" name="email" formControlName="email" data-constraints="@Required" [ngClass]="{ 'is-invalid': submitted && formControls.email.errors }">
                                    <div *ngIf="submitted && formControls.email.errors" class="text-danger">
                                        <div *ngIf="formControls.email.errors.required">* Υποχρεωτικό πεδίο</div>
                                        <div *ngIf="formControls.email.errors.email">* Το email δεν είναι έγκυρο.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- employmentType -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="experience-job-title">Σχέση Απασχόλησης</label>
                                <ng-select formControlName="employmentTypeId" [items]="employmentTypes$ | async" placeholder="Επίλεξε" id="general-information-job-category" name="resume-category" style="width: 100%">
                                </ng-select>
                            </div>
                        </div>

                        <!-- locationId -->
                        <div class="col-md-6">
                            <label class="form-label-outside" for="general-information-job-category">Περιοχή Εργασίας</label>
                            <div class="form-wrap-inner border-danger" [ngClass]="{'border-danger' : submitted && formControls.locationId.errors}">
                                <ng-select formControlName="locationId" [items]="locations$ | async" placeholder="Επίλεξε" id="general-information-job-category" name="resume-category" style="width: 100%">
                                </ng-select>
                            </div>
                            <div *ngIf="submitted && formControls.locationId.errors" class="text-danger">
                                <div *ngIf="formControls.locationId.errors.required">* Υποχρεωτικό πεδίο</div>
                            </div>
                        </div>

                        <!-- salary -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-salary">Μισθός</label>
                                <div class="form-wrap-inner">
                                    <input formControlName="salary" class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid" id="general-information-salary" type="text" name="salary" pattern="^[0-9]*$" [ngClass]="{ 'is-invalid': submitted && formControls.salary.errors }">
                                    <label class="form-label" for="general-information-salary"></label>
                                    <div *ngIf="submitted && formControls.salary.errors" class="text-danger">
                                        <div *ngIf="formControls.salary.errors.pattern">* Ο μισθός πρέπει να είναι ένας θετικός ακέραιος αριθμός.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- experience level expLvlId -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-tags">Εμπειρία</label>
                                <ng-select formControlName="expLvlId" [items]="experienceLevels$ | async" placeholder="Επίλεξε" id="general-information-job-category" name="resume-category" style="width: 100%">
                                </ng-select>
                            </div>
                        </div>

                        <!-- prerequisites -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-prerequisites">Απαιτούμενα
                                    προσόντα</label>
                                <editor id="general-information-prerequisites" formControlName="prerequisites" initialValue="" [init]="initEditorBenefitsAndPrerequisites">
                                </editor>
                            </div>
                        </div>

                        <!-- benefits -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-benefits">Προσφέρονται</label>
                                <editor id="general-information-benefits" formControlName="benefits" initialValue="" [init]="initEditorBenefitsAndPrerequisites">
                                </editor>
                            </div>
                        </div>

                        <!-- industries industryId -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-job-category">Κλάδος</label>
                                <div class="form-wrap-inner">
                                    <ng-select formControlName="industryId" (change)="selectedIndustryHandler($event)" [items]="industries$ | async" placeholder="Επίλεξε" id="general-information-job-category" name="resume-category" style="width: 100%">
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <!-- tags -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-job-category">Tags</label>
                                <div class="form-wrap-inner">
                                    <ng-select [readonly]="!postJobForm.value.industryId" id="general-information-tags" [multiple]="true" [searchable]="true" formControlName="tags" class="form-input" placeholder="Επίλεξε">
                                        <ng-option *ngFor="let tag of tags" [value]="tag.id" disabled="tag.disabled">
                                            {{tag.name}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <!-- jobUrl -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="general-information-url">Url θέσης</label>
                                <div class="form-wrap-inner">
                                    <input formControlName="jobUrl" class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid" id="general-information-url" type="text" name="url" [ngClass]="{ 'is-invalid': submitted && formControls.jobUrl.errors }">
                                    <label class="form-label" for="general-information-url"></label>
                                    <div *ngIf="submitted && formControls.jobUrl.errors" class="text-danger">
                                        <div *ngIf="formControls.jobUrl.errors.pattern">* Το url δεν είναι έγκυρο.</div>
                                        <div *ngIf="formControls.jobUrl.errors.maxlength">* Ο μέγιστος αριθμός χαρακτήρων είναι 255.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- expirationDate -->
                        <div class="col-md-6">
                            <div class="form-wrap">
                                <label class="form-label-outside" for="dateInput">Προθεσμία υποβολής αίτησης</label>
                                <div class="form-wrap-inner">
                                    <div class="input-group">
                                        <input id="dateInput" formControlName="expirationDate" class="form-control" placeholder="HH-MM-EEEE" name="dp" ngbDatepicker #d="ngbDatepicker" readonly="true" [width]="'100%'" [minDate]="minDate">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar border" (click)="d.toggle()" type="button"><img
                                                    src="/assets/images/calendar.png"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- description -->
                        <div class="col-sm-12">
                            <label class="form-label-outside" for="general-information-description">Περιγραφή</label>
                            <editor id="general-information-description" formControlName="description" initialValue="<p>Γράψτε μια περιγραφή για τη θέση εργασίας...</p>" [init]="initEditor">
                            </editor>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="block-form">
            <div class="row">
                <hr>
                <div class="col-sm-4">

                    <button class="button button-secondary" type="submit" (click)="postAJob('published')">Ενημερωση Αναρτησης</button>
                </div>
                <div class="col-sm-4">

                    <!-- <button class="button button-secondary" type="submit" (click)="postAJob()">Κοινοποιηση Αναρτησης</button> -->
                </div>
                <div style="padding-left: 10%;" class="col-sm-4">

                    <button *ngIf="jobDetails.status==='draft'" class="button button-secondary" type="submit" (click)="postAJob('draft')">Αποθηκευση Αναρτησης</button>
                </div>
            </div>
        </div>
    </div>
</section>